import { camelCase, transform, isPlainObject } from 'lodash'

export function toCamelCase<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map(toCamelCase) as unknown as T
  }

  if (!isPlainObject(obj)) {
    return obj
  }

  const result = transform(
    obj as Record<string, unknown>,
    (acc: Record<string, unknown>, value: unknown, key: string) => {
      const camelKey = camelCase(key)
      acc[camelKey] =
        isPlainObject(value) || Array.isArray(value)
          ? toCamelCase(value)
          : value
    },
    {} as Record<string, unknown>,
  )

  return result as unknown as T
}
